import { FC } from 'react';
import { Container } from 'react-bootstrap';

export const ClDrawerRight: FC = () => {
  return (
    <Container data-aos="fade-in" fluid className="cl-drawer cl-drawer-right">
      <div className="cl-drawer-right__container">
        <a href="mailto:nhanlnt@hotmail.com" target="_blank" rel="noreferrer">
          nhanlnt@hotmail.com
        </a>
      </div>
    </Container>
  );
};
